export default __webpack_public_path__ + "static/media/Amplitude-MediumItalic.6d167f1e.otf";